__turbopack_context__.v({
  "bannerContainer": "style-module-scss-module__IqGmQW__bannerContainer",
  "charcoal": "style-module-scss-module__IqGmQW__charcoal",
  "coastal": "style-module-scss-module__IqGmQW__coastal",
  "dark-teal": "style-module-scss-module__IqGmQW__dark-teal",
  "firstItem": "style-module-scss-module__IqGmQW__firstItem",
  "image": "style-module-scss-module__IqGmQW__image",
  "imageContainer": "style-module-scss-module__IqGmQW__imageContainer",
  "light-gray": "style-module-scss-module__IqGmQW__light-gray",
  "teal": "style-module-scss-module__IqGmQW__teal",
});
